<template>
  <div class="business-search-box">
    <div class="top-banner-box">
      <div class="top-banner-img"
           :style="{ backgroundImage: `url(${headerBgUrl})` }">
        <div class="top-banner-center">
          <div class="wow animate__animated animate__zoomIn banner-btn" @click="onClickLookMore">
            查看商机
          </div>
        </div>
      </div>
      <div class="top-title-value">
        <div class="wow animate__animated animate__zoomIn top-width">
          <div class="top-item" v-for="(item,index) in headerNumberList" :key="index">
            <div class="top-value">{{ item.num }}<span class="top-unit">条</span></div>
            <div class="top-name">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="input-search">
        <div class="search">
          <div v-show="showInputKey" class="search-key">
            <div class="keyword-item">
              <div class="keyword-text" v-for="(item,index) in headerSearchKeyWord" :key="'key_'+index"
                   @click="onClickKeyWord(item)">
                {{ item.name }}
              </div>
            </div>
          </div>
          <el-input placeholder="请输入关键词" v-model="headerInputSearch" clearable
                    @focus="showInputKey=true" @blur="onInputSearchBlur"></el-input>
          <div class="search-btn" @click="onClickSearch">查 询</div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="new-message">
        <div class="con-title">最新商机</div>
        <div class="con-small-title">为您汇聚最新关于潜水泵、多级泵、泥沙泵、管道泵、污水泵、双吸泵等招采信息</div>
        <el-tabs v-show="showTime" class="wow animate__animated animate__fadeInUp new-tab-box" v-model="newTabKey"
                 @tab-click="onClickNewTabClick">
          <el-tab-pane :label="item.date" :name="index.toString()" v-for="(item,index) in newBusinessList"
                       :key="item.date"></el-tab-pane>
        </el-tabs>
        <div class="wow animate__animated animate__zoomIn" v-show="showNew">
          <el-row :gutter="20" class="new-list" v-if="newBusinessList[newTabKey]">
            <el-col :span="8" class="new-item-box" v-for="(item,iIndex) in newBusinessList[newTabKey].list"
                    :key="iIndex" v-if="iIndex<6">
              <div @click="onClickDetail(item)">
                <el-card class="new-item-card">
                  <div style="padding: 10px 20px;">
                    <div class="over-num-lines over-1-lines list-item-title">{{ item.title }}</div>
                  </div>
                  <div class="list-item-bottom"
                       :style="{ backgroundImage: `url(${item.mainWorldList && item.mainWorldList[0].pic})` }">
                    <div class="list-item-info">
                      <div class="list-info-type over-num-lines" v-if="item.mainWorldList"
                           v-for="(beng,bIndex) in item.mainWorldList"
                           :key="bIndex">{{ beng.name }}
                      </div>
                      <div class="list-info-local over-num-lines">{{ item.municipalName }}</div>
                    </div>
                    <div class="over-num-lines over-2-lines list-item-des">{{ item.summary }}</div>
                    <div class="list-item-date">发布日期：{{ item.publishDate }}</div>
                  </div>
                </el-card>
              </div>
            </el-col>
          </el-row>
          <div class="list-item-more" @click="onClickLookMore">查看更多</div>
        </div>
      </div>
    </div>
    <div class="business-map big-img" :style="{ backgroundImage: `url(${businessMapUrl})` }">
      <div>
        <div class="map-box">
          <amap style="height: 800px;width:100%;" :mapInfoList="mapInfoList"/>
          <div>
            <div class="map-title">商机分布</div>
            <div class="map-btn-list">
              <el-checkbox :indeterminate="mapIsIndeterminate" v-model="mapCheckAll"
                           style="margin-right: 30px;" @change="handleCheckAllChange">全选
              </el-checkbox>
              <el-checkbox-group v-model="mapParams.mapCheckList" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="item in mapKeyWord" :label="item.uuid" :key="item.uuid">
                  {{ item.name }}
                </el-checkbox>
              </el-checkbox-group>
              <el-select style="margin-left: 50px;" v-model="mapParams.mapDate" size="mini"
                         placeholder="请选择时间段" @change="getMapRightInfo">
                <el-option
                    v-for="item in dateOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div>
              <div v-show="showMap" class="wow animate__animated animate__fadeInRight map-info">
                <div class="map-box-top">
                  <div class="map-top-row-01">序号</div>
                  <div class="map-top-row-02">分布地区</div>
                  <div class="map-top-row-03">商机数量</div>
                </div>
                <div class="map-box-item-com" :class="index%2?'map-box-item-green':'map-box-item-white'"
                     v-for="(item,index) in mapRightStaticList" :key="index" v-if="index<8">
                  <div class="map-top-row-01 over-num-lines">{{ index + 1 }}</div>
                  <div class="map-top-row-02 over-num-lines">{{ item.name }}</div>
                  <div class="map-top-row-03 over-num-lines">{{ item.count }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="big-box tender-info" :style="{ backgroundImage: `url(${tenderInfoUrl})` }">
      <div class="container">
        <div class="con-title" style="color: white;">海量泵业招采信息</div>
        <el-row :gutter="20" class="tender-tab">
          <el-col :span="5" v-for="(item,index) in tenderBtnList" :key="index">
            <div class="tab-btn-com" :class="item.uuid===paramsData.programUuid?'tab-btn-select':'tab-btn-normal'"
                 @click="onClickTender(item)">{{ item.title }}
            </div>
          </el-col>
        </el-row>
        <div v-show="showTender" class="wow animate__animated animate__fadeIn">
          <el-row :gutter="35" class="tender-list">
            <el-col :span="8" class="tender-item-box" v-for="(item,index) in tendAndBuyList" :key="index">
              <div class="tender-item-card" @click="onClickDetail(item)">
                <div class="tender-item-status" :style="item.isEnd ? 'background-color: rgb(157, 157, 157);' : ''">
                  {{ item.isEnd ? '已结束' : '进行中' }}
                </div>
                <div class="tender-item-label over-num-lines">
                  {{ paramsData.programTitle.indexOf('中标') > -1 ? '中标金额' : '预算金额' }}：
                  <span class="tender-item-num">{{ item.money || '详见招标文件' }}</span>
                  <!--                  <span class="tender-item-unit">元</span>-->
                </div>
                <div class="over-num-lines over-2-lines tender-item-info">
                  <span class="tender-item-type">{{ item.programName }}</span><span
                    class="tender-item-title">{{ item.title }}</span>
                </div>
                <div class="tender-item-bottom">
                  <div style="margin-bottom: 3px;">发布时间：{{ item.publishDate }}</div>
                  <div class="over-num-lines over-2-lines">企业名称：{{ item.company }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
          <div class="tender-item-more" @click="onClickLookMore">查看更多</div>
        </div>
      </div>
    </div>
    <div class="container" style="width: 1220px;">
      <div class="company-card">
        <el-row :gutter="30">
          <el-col :span="12">
            <div v-show="showCompany" class="wow animate__animated animate__fadeInLeft company-item-box"
                 :style="{ backgroundImage: `url(${companyLeftUrl})` }">
              <div class="company-item-padding">
                <div class="company-title">最新招采单位</div>
                <div class="company-des over-num-lines over-2-lines">
                  查看最新招标采购单位，发现商机
                </div>
                <div class="company-list-box">
                  <div class="company-list-item" v-for="(item,index) in newTendCompanyList" :key="index">
                    <span class="company-dot"></span>
                    <div class="over-num-lines over-1-lines" @click="onClickDetail(item)">
                      {{ item.company }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div v-show="showCompany" class="wow animate__animated animate__fadeInRight company-item-box"
                 :style="{ backgroundImage: `url(${companyRightUrl})` }">
              <div class="company-item-padding">
                <div class="company-title">最新中标单位</div>
                <div class="company-des over-num-lines over-2-lines">
                  查看中标单位，了解同行中标信息
                </div>
                <div class="company-list-box">
                  <div class="company-list-item" v-for="(item,index) in getCompanyList" :key="index">
                    <span class="company-dot"></span>
                    <div class="over-num-lines over-1-lines" @click="onClickDetail(item)">
                      {{ item.company }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="container" style="width: 1220px;">
      <div class="info-location" v-show="showInfoLocation">
        <el-row :gutter="30">
          <el-col :span="12" class="wow animate__animated animate__fadeInLeftBig">
            <div class="left-right-box" :style="{ backgroundImage: `url(${infoLocationLeftUrl})` }">
              <div class="left-right-title">为您推荐</div>
              <div class="left-item" v-for="(item,index) in recommendList" :key="index" @click="onClickDetail(item)">
                <el-row :gutter="10">
                  <el-col :span="4">
                    <div class="info-type">{{ item.programName }}</div>
                  </el-col>
                  <el-col :span="15">
                    <div class="over-num-lines over-1-lines">{{ item.title }}</div>
                  </el-col>
                  <el-col :span="5">
                    <div class="info-date">{{ item.publishDate.split(' ')[0] }}</div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
          <el-col :span="12" class="wow animate__animated animate__fadeInRightBig">
            <div class="left-right-box" :style="{ backgroundImage: `url(${infoLocationRightUrl})` }">
              <div class="left-right-title">地区导航</div>
              <div class="right-item" v-for="(lo,index) in regionList" :key="index">
                <div class="location-type">{{ lo.name }}</div>
                <div class="location-list">
                  <div class="location-item" v-for="(item,lIndex) in lo.provinceList" :key="lIndex"
                       @click="onClickProvince(item)">{{ item.shortName }}
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="big-box" style="height: 460px;" :style="{ backgroundImage: `url(${activityUrl})` }">
      <div class="container">
        <div class="con-title" style="color: white;">相关活动</div>
        <div class="activity-box">
          <div class="activity-des over-num-lines">水泵行业展览会，交流会等活动信息</div>
          <div>
            <el-carousel indicator-position="outside" :autoplay="true">
              <el-carousel-item v-for="(item,index) in activityList" :key="item.createDate">
                <div class="activity-carousel" @click="onClickActivityDetail(item)">
                  <img class="carousel-img" :src="`${item.pic}`" alt="">
                  <div class="carousel-box">
                    <div class="carousel-title over-num-lines over-2-lines">{{ item.name }}</div>
                    <div class="carousel-des over-num-lines over-2-lines">{{ item.summary }}</div>
                    <div class="carousel-date">发布日期：{{ item.createDate }}</div>
                  </div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getDictionaryItem,
  getFrontActivityList,
  getFrontCityTree,
  getFrontDoingList,
  getFrontHotNeedList,
  getFrontItemList,
  getFrontKeyWorld,
  getFrontNewDate,
  getFrontProgramList,
  getFrontStaticInfo,
  getFrontTendAndBuyList,
  getModelMapInfo,
  getModelMapStatic,
} from "../../utils/interface";
import {mapState} from "vuex";
import amap from "../amap/index";

export default {
  //   商机线索
  name: "saas",
  metaInfo: {
    title: '商机线索 - 为水泵行业企业提供信息化商机线索服务-水泵云',
    meta: [{
      name: 'keywords',
      content: '水泵云 | 信息化软件 | 智能制造解决方案| 水泵数字化| saas平台 | 平台软件服务 | 企业数字化服务| 企业管理软件'
    }, {
      name: 'description',
      content: '水泵云软件超市提供人力资源、行政、采购、营销、财务、党政等信息化产品软件服务，为水泵行业企业提供完整的信息化解决方案。'
    }],
  },
  components: {amap,},
  data() {
    return {
      headerBgUrl: '',
      tenderInfoUrl: require('../../assets/tenderInfoBg.png'),
      businessMapUrl: require('../../assets/businessMapBg.png'),
      companyLeftUrl: require('../../assets/companyLeft.png'),
      companyRightUrl: require('../../assets/companyRight.png'),
      infoLocationLeftUrl: require('../../assets/infoLocationLeft.png'),
      infoLocationRightUrl: require('../../assets/infoLocationRight.png'),
      activityUrl: require('../../assets/activeBg.png'),
      headerInputSearch: '',
      headerSearchKeyWord: [],
      headerNumberList: [
        {num: 0, title: '今日商机更新', key: 'todayCount'},
        {num: 0, title: '招标信息', key: 'tenderCount'},
        {num: 0, title: '采购信息', key: 'purchaseCount'},
        {num: 0, title: '中标信息', key: 'doingCount'},
        {num: 0, title: '累计发布', key: 'totalCount'},
      ],
      showInputKey: false,
      newTabList: [],
      newTabKey: '0',
      showNew: false,
      showMap: false,
      showTime: false,
      showTender: false,
      showCompany: false,
      showInfoLocation: false,
      tenderBtnIndex: 0,
      tenderBtnList: [],
      newBusinessList: [],
      tendAndBuyList: [],
      paramsData: {
        programUuid: '',
        programTitle: '',
        status: 1,
        current: '1',
        pageSize: '6',
      },
      newTendCompanyList: [],
      getCompanyList: [],
      recommendList: [],
      regionList: [],
      activityList: [],
      mapParams: {
        mapCheckList: [],
        mapDate: '',
      },
      mapCheckAll: true,
      mapIsIndeterminate: false,
      mapInfoList: [],
      dateOptions: [
        {label: '全部', value: '',},
        {label: '七天', value: 'WEEK',},
        {label: '一个月', value: 'MONTH',},
        {label: '三个月', value: 'THREE_MONTH',},
        {label: '半年', value: 'YEAR',},
      ],
      mapKeyWord: [],
      mapKeyAllWord: [],
      mapRightStaticList: [],
    };
  },
  computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  created() {
    if (this.$store.state.isLogin) {

    } else {

    }
    this.getOptionsData()
  },
  mounted() {
    window.addEventListener("scroll", this.menu);
  },
  methods: {
    onClickSearch() {
      this.toSearchList()
    },
    toSearchList() {
      let routeData = this.$router.resolve({
        path: "/businessSearchList",
        query: {
          search: this.headerInputSearch,
        }
      })
      this.showInputKey = false
      window.open(routeData.href, "_blank");
    },
    //延迟关闭，事件触发后再关闭
    onInputSearchBlur() {
      let that = this
      setTimeout(function () {
        that.showInputKey = false
      }, 100)
    },
    onClickNewTabClick() {
      // this.$nextTick(() => {
      //   this.getNewBusinessList()
      // })
    },
    onClickDetail(item) {
      let routeData = this.$router.resolve({
        name: "businessSearchDetails",
        params: {uuid: item.uuid},
        query: {
          titleName: "商机线索",
          titleForm: "businessSearch",
        }
      });
      window.open(routeData.href, "_blank");
    },
    onClickActivityDetail(item) {
      let routeData = this.$router.resolve({
        name: "businessActivityDetails",
        params: {uuid: item.uuid},
        query: {
          titleName: "商机线索",
          titleForm: "businessSearch",
        }
      });
      window.open(routeData.href, "_blank");
    },
    onClickKeyWord(item) {
      this.headerInputSearch = item.name
      this.onClickSearch()
    },
    onClickLookMore() {
      let routeData = this.$router.resolve({
        path: "/businessSearchList",
        query: {
          programUuid: this.paramsData.programUuid || '-1',
        }
      })
      window.open(routeData.href, "_blank");
    },
    onClickFav(item) {
      item.isFav = 1 - item.isFav
      this.onClickLogin()
    },
    onClickLogin() {
      this.$router.push("/login");
    },
    getOptionsData() {
      //设置时间
      // this.newTabList = [
      //   {label: '今天', name: moment().format('YYYY-MM-DD')},
      //   {label: moment().subtract(1, 'day').format('MM.DD'), name: moment().subtract(1, 'day').format('YYYY-MM-DD')},
      //   {label: moment().subtract(2, 'day').format('MM.DD'), name: moment().subtract(2, 'day').format('YYYY-MM-DD')},
      //   {label: moment().subtract(3, 'day').format('MM.DD'), name: moment().subtract(3, 'day').format('YYYY-MM-DD')},
      //   {label: moment().subtract(4, 'day').format('MM.DD'), name: moment().subtract(4, 'day').format('YYYY-MM-DD')},
      //   {label: moment().subtract(5, 'day').format('MM.DD'), name: moment().subtract(5, 'day').format('YYYY-MM-DD')},
      //   {label: moment().subtract(6, 'day').format('MM.DD'), name: moment().subtract(6, 'day').format('YYYY-MM-DD')},
      // ]
      // this.newTabKey = moment().format('YYYY-MM-DD')
      this.getNewBusinessList()
      this.getItemList()
      this.getMapRightInfo()

      //顶部轮播图
      getDictionaryItem({
        code: 'TENDERING_BACKGROUD'
      }).then((res) => {
        if (res != null && res.length > 0) {
          this.headerBgUrl = res[0].value
        } else {
          this.headerBgUrl = ''
        }
      });

      getFrontKeyWorld().then((res) => {
        if (res != null && res.length > 0) {
          this.headerSearchKeyWord = res
          this.mapKeyWord = [...res]
          this.mapKeyAllWord = this.mapKeyWord.map(item => item.uuid)
          this.mapParams.mapCheckList = this.mapKeyWord.map(item => item.uuid)
        } else {
          this.headerSearchKeyWord = []
          this.mapKeyWord = []
        }
      });

      getFrontStaticInfo().then((res) => {
        if (res) {
          this.headerNumberList.forEach(item => {
            item.num = res[item.key]
          })
        } else {
          this.headerNumberList = []
        }
      });

      getFrontProgramList().then((res) => {
        if (res) {
          this.tenderBtnList = res
          this.tenderBtnList.unshift({title: '全部', uuid: ''})
        } else {
          this.tenderBtnList = []
        }
      });

      getFrontTendAndBuyList().then((res) => {
        if (res) {
          this.newTendCompanyList = res
        } else {
          this.newTendCompanyList = []
        }
      });

      getFrontDoingList().then((res) => {
        if (res) {
          this.getCompanyList = res
        } else {
          this.getCompanyList = []
        }
      });

      getFrontHotNeedList().then((res) => {
        if (res) {
          this.recommendList = res
        } else {
          this.recommendList = []
        }
      });

      getFrontCityTree().then((res) => {
        if (res.data) {
          this.regionList = res.data
        } else {
          this.regionList = []
        }
      });

      getFrontActivityList({status: '1'}).then((res) => {
        if (res) {
          this.activityList = res
        } else {
          this.activityList = []
        }
      });

      getModelMapStatic({}).then((res) => {
        if (res.data) {
          this.mapRightStaticList = res.data
        } else {
          this.mapRightStaticList = []
        }
      });
    },
    handleCheckAllChange(val) {
      this.mapParams.mapCheckList = val ? this.mapKeyAllWord : []
      this.mapIsIndeterminate = false
      this.getMapRightInfo()
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length
      this.mapCheckAll = checkedCount === this.mapKeyAllWord.length
      this.mapIsIndeterminate = checkedCount > 0 && checkedCount < this.mapKeyAllWord.length
      this.getMapRightInfo()
    },
    getMapRightInfo() {
      let data = {
        keyWorld: this.mapParams.mapCheckList,
        dateType: this.mapParams.mapDate,
      }
      getModelMapInfo(data).then((res) => {
        if (res.data) {
          this.mapInfoList = res.data
        } else {
          this.mapInfoList = []
        }
      });
    },
    getItemList() {
      getFrontItemList(this.paramsData).then((res) => {
        if (res.list) {
          this.tendAndBuyList = res.list
        } else {
          this.tendAndBuyList = []
        }
      });
    },
    getNewBusinessList() {
      getFrontNewDate().then((res) => {
        if (res != null && res.length > 0) {
          this.newBusinessList = res
        } else {
          this.newBusinessList = []
        }
      });
    },
    onClickProvince(item) {
      let routeData = this.$router.resolve({
        path: "/businessSearchList",
        query: {
          cityUuid: item.uuid,
          type: item.type,
        }
      })
      window.open(routeData.href, "_blank");
    },
    onClickTender(item) {
      if (item.type === 2) {
        window.open(item.url, "_blank");
      } else {
        this.paramsData.programUuid = item.uuid
        this.paramsData.programTitle = item.title
        this.getItemList()
      }
    },
    // 页面滚动
    menu() {
      //这里是pc端
      let scroll = document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(scroll)
      let newHeight = 464
      if (this.newBusinessList[this.newTabKey].hasOwnProperty('list') && this.newBusinessList[this.newTabKey].list.length > 0) {
        if (this.newBusinessList[this.newTabKey].list.length > 0 && this.newBusinessList[this.newTabKey].list.length < 3) {
          newHeight = 232
        } else {
          newHeight = 0
        }
      }
      if (scroll > 50) {
        this.showTime = true
      }
      if (scroll > 130) {
        this.showNew = true
      }
      if (scroll > 1100 - newHeight) {
        this.showMap = true
      }
      if (scroll > 1800 - newHeight) {
        this.showTender = true
      }
      if (scroll > 2400 - newHeight) {
        this.showCompany = true
      }
      if (scroll > 2900 - newHeight) {
        this.showInfoLocation = true
      }
    },
  },
};
</script>

<style scoped lang="less">
@basic-colors: #009999;

.business-search-box {
  background-color: #f7f8fb;

  //超出指定行换行
  .over-num-lines {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .over-1-lines {
    -webkit-line-clamp: 1;
  }

  .over-2-lines {
    -webkit-line-clamp: 2;
  }

  .container {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 10px;
  }

  .big-box {
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding-bottom: 52px;
    padding-top: 5px;
  }

  .con-title {
    font-size: 24px;
    font-weight: bold;
    color: #000;
    text-align: center;
    margin-top: 40px;
  }

  .con-small-title {
    color: #333333;
    text-align: center;
    margin-top: 10px;
  }

  .top-banner-box {
    .top-banner-img {
      height: 500px;
      width: 100%;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .top-banner-center {
        width: 1200px;
        height: 500px;
        position: relative;
      }

      .banner-btn {
        width: 130px;
        margin-left: 20px;
        background-color: white;
        color: @basic-colors;
        letter-spacing: 2px;
        text-align: center;
        padding: 12px 0;
        border-radius: 7px;
        cursor: pointer;
        user-select: none;
        position: absolute;
        bottom: 150px;
        transition: all .2s;
      }

      .banner-btn:active {
        transform: scale(1.02);
      }
    }

    .top-title-value {
      background: white;
      box-shadow: rgba(173, 173, 183, 0.2) 0 7px 18px 0;
      padding: 20px 0;
      display: flex;
      justify-content: center;
      align-items: center;

      .top-width {
        width: 1200px;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .top-item {
        width: 20%;
        text-align: center;
      }

      .top-value {
        font-size: 36px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #15A9A9;
        line-height: 36px;
      }

      .top-unit {
        font-size: 18px;
      }

      .top-name {
        font-size: 16px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #333333;
      }
    }
  }

  .input-search {
    display: flex;
    justify-content: center;

    .search {
      width: 900px;
      margin-top: 30px;
      position: relative;

      /deep/ .el-input__inner {
        height: 70px;
        line-height: 70px;
        font-size: 16px;
        border-radius: 35px;
        box-shadow: rgba(100, 100, 111, 0.2) 0 7px 29px 0;
        padding-right: 200px;
        padding-left: 25px;
        transition: all .2s;
      }

      /deep/ .el-input__inner:focus {
        box-shadow: 0 -7px 8px rgba(100, 100, 111, 0.1);
        outline: 0;
        border: 1px solid #f1f1f1;
        border-radius: 35px 35px 0 0;
      }

      /deep/ .el-input__suffix {
        font-size: 22px;
        position: absolute;
        height: 100%;
        right: 165px;
        top: 7px;
        text-align: center;
        color: #c0c4cc;
        -webkit-transition: all .3s;
        -o-transition: all .3s;
        transition: all .3s;
        pointer-events: none;
      }

      /deep/ .el-icon-circle-close:before {
        font-size: 22px;
      }

      .search-btn {
        position: absolute;
        right: 7px;
        top: 7px;
        text-align: center;
        width: 150px;
        height: 56px;
        line-height: 56px;
        border-radius: 30px;
        background: linear-gradient(to right, #01E9BD, #15A9A9);
        font-size: 18px;
        font-weight: bold;
        color: #FFFFFF;
        cursor: pointer;
        user-select: none;
        transition-duration: 0.2s;
      }

      .search-btn:hover {
        transform: scale(1.02);
        transition-duration: 0.2s;
      }

      .search-btn:active {
        transform: scale(1);
        transition-duration: 0.2s;
      }

      .search-key {
        width: 100%;
        background-color: white;
        border-radius: 0 0 35px 35px;
        position: absolute;
        top: 50px;
        padding-bottom: 40px;
        box-shadow: 0 7px 20px rgba(100, 100, 111, 0.2);
      }

      .keyword-item {
        padding-top: 50px;
        display: flex;
        padding-left: 12px;
      }

      .keyword-text {
        margin: 0 10px;
        line-height: 18px;
        cursor: pointer;
        user-select: none;
      }

      .keyword-text:hover {
        color: @basic-colors;
        transition-duration: 0.2s;
      }

      .keyword-text:active {
        color: #FFFFFF;
        transition-duration: 0.2s;
      }
    }
  }

  .new-message {
    /deep/ .el-tabs__nav-scroll {
      overflow: hidden;
      display: flex;
      justify-content: center;
    }

    /deep/ .el-tabs__item {
      padding: 0 65px;
      font-size: 16px;
    }

    /deep/ .el-tabs__item.is-active {
      font-weight: bold;
    }

    .new-tab-box {
      margin-top: 40px;
    }

    .new-list {
      margin-top: 10px;
    }

    .new-item-box {
      margin-bottom: 20px;

      /deep/ .el-card__body {
        padding: 0;
      }
    }

    .new-item-card {
      background-color: #f9f9f9;
      transition: all .2s;
      cursor: pointer;
    }

    .new-item-card:hover {
      border: 1px solid @basic-colors;
      transform: scale(1.02);
    }

    .list-item-title {
      font-size: 17px;
      font-weight: bold;
      color: #333333;
      text-align: center;
      line-height: 28px;
      height: 28px;
    }

    .list-item-bottom {
      background-repeat: no-repeat;
      background-position: 95%, 50%;
      background-size: 133px 117px;
      background-color: white;
      padding: 10px 20px 0 10px;
      height: 124px;
    }

    .list-item-info {
      font-size: 14px;
      display: flex;
    }

    .list-info-type {
      background: #8ad4d4;
      border-radius: 15px;
      color: @basic-colors;
      padding: 0 5px;
      margin-right: 5px;
      max-width: 120px;
    }

    .list-info-local {
      background: #bed9f7;
      border-radius: 15px;
      color: #2a8fff;
      padding: 0 5px;
      max-width: 120px;
    }

    .list-item-des {
      height: 46px;
      margin-top: 8px;
      font-size: 14px;
      color: #9a9b9b;
      line-height: 23px;
    }

    .list-item-date {
      margin-top: 15px;
      font-size: 14px;
      font-weight: bold;
      color: #333333;
    }

    .list-item-more {
      text-align: center;
      font-size: 14px;
      letter-spacing: 2px;
      color: #000;
      cursor: pointer;
      user-select: none;
      transition: all .2s;
      margin: 10px 0 30px 0;
    }

    .list-item-more:hover {
      color: @basic-colors;
    }
  }

  .business-map {
    height: 800px;
    width: 100%;

    .big-img {
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }

    .map-title {
      font-size: 24px;
      font-weight: bold;
      color: #000;
      text-align: center;
      padding-top: 40px;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }

    .map-btn-list {
      width: fit-content;
      position: absolute;
      top: 110px;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
    }


    .map-checkbox {
      margin-top: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .map-right-box {
      width: 1200px;
      text-align: right;
      display: flex;
      justify-content: end;
      align-items: center;
      margin: 80px auto auto;
      pointer-events: none;
    }

    .map-box {
      position: relative;
    }

    .map-info {
      width: 330px;
      height: 460px;
      background: #15A9A9;
      box-shadow: 0 0 15px 0 rgb(0, 153, 153);
      border-radius: 12px;
      padding: 20px;
      position: absolute;
      top: 200px;
      left: 1160px;
    }

    .map-box-top {
      display: flex;
      color: white;
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 20px;
      padding: 0 5px;
    }

    .map-top-row-01 {
      width: 16%;
    }

    .map-top-row-02 {
      width: 60%;
      text-align: center;
    }

    .map-top-row-03 {
      width: 24%;
      text-align: right;
    }

    .map-box-item-com {
      display: flex;
      font-size: 16px;
      margin-bottom: 8px;
      padding: 12px 20px;
      border-radius: 5px;
    }

    .map-box-item-white {
      color: #3ab2b4;
      background-color: #eaf4fe;
    }

    .map-box-item-green {
      color: #eaf4fe;
      background-color: #40b8ba;
    }
  }

  .tender-info {
    height: 700px;

    .tender-tab {
      color: white;
      margin-top: 40px;
      padding: 0 50px;
    }

    .tab-btn-com {
      width: 150px;
      height: 42px;
      line-height: 42px;
      text-align: center;
      border-radius: 10px;
      cursor: pointer;
      user-select: none;
    }

    .tab-btn-normal {
      background-color: rgba(255, 255, 255, 0.1);
      color: white;
      border: 1px solid white;
    }

    .tab-btn-select {
      background-color: white;
      color: #333333;
      font-weight: bold;
    }

    /deep/ .el-col-5 {
      max-width: 20%;
      flex: 0 0 20%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .tender-item-more {
      text-align: center;
      font-size: 14px;
      letter-spacing: 2px;
      cursor: pointer;
      user-select: none;
      transition: all .2s;
      margin: 10px 0 30px 0;
      color: white;
    }

    .tender-item-more:hover {
      color: @basic-colors;
    }

    .tender-item-card {
      position: relative;
      background-color: white;
      height: 170px;
      padding: 20px;
      cursor: pointer;
      transition: all .2s;
    }

    .tender-item-card:hover {
      transform: scale(1.02);
      box-shadow: rgba(100, 100, 111, 0.2) 0 7px 29px 0;
    }

    .tender-list {
      height: 490px;
      margin-top: 45px;
    }

    .tender-item-box {
      margin-bottom: 35px;
    }

    .tender-item-status {
      position: absolute;
      right: 0;
      top: 0;
      background-color: @basic-colors;
      color: white;
      width: 80px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      font-size: 14px;
    }

    .tender-item-label {
      color: #333333;
      font-weight: bold;
      margin-top: 12px;
    }

    .tender-item-num {
      color: #dc3223;
      font-size: 20px;
      font-weight: bold;
    }

    .tender-item-unit {
      color: #dc3223;
    }

    .tender-item-info {
      margin-top: 15px;
      line-height: 28px;
    }

    .tender-item-type {
      background: #bed9f7;
      color: #2a8fff;
      padding: 1px 6px;
      font-size: 14px;
      margin-right: 8px;
    }

    .tender-item-title {
      font-weight: bold;
      color: #333333;
    }

    .tender-item-bottom {
      color: #aeaeae;
      font-size: 14px;
      margin-top: 15px;
    }
  }

  .company-card {
    margin-top: 50px;
    color: #333333;

    .company-item-box {
      background-repeat: no-repeat;
      background-size: 600px 557px;
      width: 600px;
      height: 557px;
      overflow: hidden;
    }

    .company-item-padding {
      padding: 30px 35px;
    }

    .company-title {
      font-size: 22px;
      font-weight: bold;
      line-height: 36px;
    }

    .company-des {
      margin-top: 8px;
      font-size: 14px;
      line-height: 24px;
    }

    .company-list-box {
      margin-top: 12px;
    }

    .company-list-item {
      font-size: 16px;
      line-height: 40px;
      display: flex;
      align-items: center;
      cursor: pointer;
      transition: all .2s;
    }

    .company-list-item:hover {
      color: @basic-colors;
    }

    .company-dot {
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background-color: #333333;
      margin-right: 10px;
    }
  }

  .info-location {
    margin-top: 20px;

    /deep/ .el-card {
      border-radius: 15px;
    }

    .left-right-box {
      background-size: 600px 450px;
      background-repeat: no-repeat;
      padding: 30px 35px;
      height: 400px;
    }

    .left-right-title {
      font-size: 22px;
      font-weight: bold;
      margin-bottom: 18px;
    }

    .left-item {
      margin-bottom: 22px;
      cursor: pointer;
    }

    .left-item:hover {
      color: @basic-colors;
    }

    .info-type {
      width: 80px;
      text-align: center;
      background: #bed9f7;
      color: #2a8fff;
      padding: 1px 0;
      font-size: 14px;
      margin-right: 10px;
    }

    .info-date {
      text-align: right;
      font-size: 14px;
      color: #9b9b9b;
    }

    .right-item {
      display: flex;
      margin-bottom: 12px;
    }

    .location-type {
      width: 70px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: #8ad4d47d;
      color: @basic-colors;
      font-size: 16px;
      margin-right: 8px;
    }

    .location-list {
      width: calc(100% - 70px);
      display: flex;
      flex-wrap: wrap;
      margin-left: 10px;
    }

    .location-item {
      width: 62px;
      height: 30px;
      line-height: 30px;
      cursor: pointer;
      font-size: 15px;
    }

    .location-item:hover {
      color: @basic-colors;
    }
  }

  .activity-box {
    padding: 0 45px;

    .activity-des {
      color: white;
      text-align: center;
      margin-top: 15px;
    }

    /deep/ .el-carousel__container {
      position: relative;
      height: 320px;
    }

    .activity-carousel {
      display: flex;
      justify-content: center;
      //align-items: center;
      cursor: pointer;
      margin-top: 40px;
      background-color: white;
      padding: 20px;
      border-radius: 10px;
    }

    .carousel-img {
      height: 230px;
      width: 330px;
      border-radius: 10px;
    }

    .carousel-box {
      width: calc(100% - 330px);
      margin-left: 40px;
    }

    .carousel-title {
      font-size: 26px;
      font-weight: bold;
      line-height: 36px;
      color: #333333;
    }

    .carousel-des {
      margin-top: 30px;
      color: #a3a3a3;
    }

    .carousel-date {
      color: #a3a3a3;
      margin-top: 40px;
    }

    /deep/ .el-carousel__arrow--left {
      right: 120px;
      top: calc(100% - 50px);
      left: unset;
    }

    /deep/ .el-carousel__arrow--right {
      right: 50px;
      top: calc(100% - 50px);
      left: unset;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/businessSearch/index.vue